import { render, staticRenderFns } from "./AbkMessage.vue?vue&type=template&id=b317e2c8&scoped=true&"
import script from "./AbkMessage.vue?vue&type=script&lang=js&"
export * from "./AbkMessage.vue?vue&type=script&lang=js&"
import style0 from "./AbkMessage.vue?vue&type=style&index=0&id=b317e2c8&scoped=true&lang=scss&"
import style1 from "./AbkMessage.vue?vue&type=style&index=1&id=b317e2c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b317e2c8",
  null
  
)

export default component.exports